export interface FloodSensitivityOption {
    label: string;
    value: string;
}

export function floodSensitivity(): FloodSensitivityOption[] {
    return [
        { label: "not_specified", value: "" },
        { label: "A", value: "A" },
        { label: "B", value: "B" },
        { label: "C", value: "C" },
        { label: "D", value: "D" }
    ];
}
